module.exports = __webpack_public_path__ + "img/img_13.e3aefcc6.jpg";